export default {
  GA_TRACKERS: ['MSOCIAL', 'AGENCY'],
};
